"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const siteText_1 = tslib_1.__importDefault(require("../mixins/siteText"));
const sitetext_1 = require("../filters/sitetext");
const SlideHeader_vue_1 = tslib_1.__importDefault(require("./SlideHeader.vue"));
const lottie_web_1 = tslib_1.__importDefault(require("lottie-web"));
const confirmation_error_64_1 = require("../assets/confirmation-error-64");
exports.default = vue_1.default.extend({
    name: 'sync-failure',
    props: {
        buttonText: {
            type: String,
            default: '',
        },
        url: {
            type: String,
            default: '',
        },
    },
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    computed: {
        errorMessage() {
            const errors = this.$store.state.errors;
            let errorCode = '';
            if (errors.length > 0) {
                errorCode = errors[0].CustomSubCode;
            }
            if (errorCode !== null && errorCode.startsWith('AEC')) {
                return this.getSiteText(`Sync.SyncError.${errorCode}`);
            }
            else {
                return this.getSiteText('Error.Generic');
            }
        },
    },
    components: {
        SlideHeader: SlideHeader_vue_1.default,
    },
    mounted() {
        lottie_web_1.default.loadAnimation({
            container: document.querySelector('.syncAnimation.error'),
            renderer: 'svg',
            animationData: confirmation_error_64_1.ConfirmationError64,
            loop: false,
            autoplay: true,
        });
    },
});
